import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {fuseAnimations} from "../../../@fuse/animations";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Service} from "../models/service";
import {MessageTemplate} from "../models/messageTemplate";
import {MessageTemplateService} from "../services/messageTemplate.service";
import {MarketingActionService} from "../services/marketingAction.service";
import {MarketingAction} from "../models/marketingAction";
import {SignUpActionService} from "../services/signUpAction.service";
import {NotificationAccountService} from "../services/notificationAccount.service";
import {SignUpAction} from "../models/signUpAction";
import {NotificationAccount} from "../models/notificationAccount";

@Component({
    templateUrl: './marketingActionForm.component.html',
    styleUrls: ['./marketingActionForm.component.scss'],
    animations   : fuseAnimations
})

export class MarketingActionFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    dialogRef: any;
    availableServices: Service[];
    signUpActions: SignUpAction[];
    messageTemplates: MessageTemplate[];
    notificationAccounts: NotificationAccount[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private _matSnackBar: MatSnackBar,
        private marketingActionService: MarketingActionService,
        private signUpActionService: SignUpActionService,
        private messageTemplateService: MessageTemplateService,
        private notificationAccountService: NotificationAccountService,
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Marketing actions');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.signUpActionService.getAll(0, 200).pipe(first())
            .subscribe( res => {
                    this.signUpActions = res.items;
                },
                error => {
                    this.alertService.error(error);
                });

        this.messageTemplateService.getAll(0, 200).pipe(first())
            .subscribe( res => {
                    this.messageTemplates = res.items;
                },
                error => {
                    this.alertService.error(error);
                });

        this.notificationAccountService.getAll(0, 200).pipe(first())
            .subscribe( res => {
                    this.notificationAccounts = res.items;
                },
                error => {
                    this.alertService.error(error);
                });

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
            expression: ['', Validators.required],
            actionVoucher: [],
            messageTemplate: [],
            notificationAccount: [],
        });

        if (!this.isAddMode) {
            this.marketingActionService.getById(this.id)
                .pipe(first())
                .subscribe((x: MarketingAction) => {
                    this.f.name.setValue(x.name);
                    this.f.expression.setValue(x.expression);
                    if (x.actionVoucher) {
                        this.f.actionVoucher.setValue(x.actionVoucher.id);
                    }

                    if (x.messageTemplate) {
                        this.f.messageTemplate.setValue(x.messageTemplate.id);
                    }

                    if (x.notificationAccount) {
                        this.f.notificationAccount.setValue(x.notificationAccount.id);
                    }
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        // this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createMarketingAction();
        } else {
            this.updateMarketingAction();
        }
    }

    private createMarketingAction() {
        this.marketingActionService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Marketing action added successfully', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.loading = false;
                    this._matSnackBar.open('Marketing action creation error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                });
    }

    private updateMarketingAction() {
        this.marketingActionService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this._matSnackBar.open('Update successful', 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-success']
                    });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this._matSnackBar.open('Marketing action update error - ' + error, 'OK', {
                        verticalPosition: 'top',
                        duration        : 5000,
                        panelClass: ['snackbar-error']
                    });
                    this.loading = false;
                });
    }
}
